import React from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface BreadCrumbProps {
  title: string;
  linkTitle: string;
  hasBackButton?: boolean;
  backLink?: string;
  handleBack?: () => void;
  prevMenu?: boolean;
}

const BreadCrumbForm = ({
  title = "",
  linkTitle = "",
  hasBackButton = false,
  backLink = "",
  handleBack = () => {},
  prevMenu = true,
}: BreadCrumbProps) => {
  const routes = all_routes;

  return (
    <>
      <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <div className="my-auto mb-2">
          <h2 className="mb-1">{title}</h2>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.employeeDashboard}>
                  <i className="ti ti-smart-home" />
                </Link>
              </li>
              {prevMenu && (
                <li className="breadcrumb-item">Work & Operations</li>
              )}
              <li className="breadcrumb-item active" aria-current="page">
                {linkTitle}
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center justify-content-end flex-wrap ">
          {hasBackButton && (
            <div className="mb-2">
              <Link
                to={backLink}
                className="btn btn-secondary d-flex align-items-center"
                onClick={() => handleBack?.()}
              >
                <i className="bi bi-arrow-left me-2"></i> Back
              </Link>
            </div>
          )}
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>
      </div>
    </>
  );
};

export default BreadCrumbForm;
